module.exports = __webpack_public_path__ + "img/img-sicbo-s.9e08d412.png";